import React from 'react';
import { ArrowRight, Check, Info } from 'lucide-react';
import { pricingTiers, pricingDisclaimer } from '../config/pricing';
import PackageFitQuiz from './PackageFitQuiz';

const Pricing = () => (
  <section id="pricing" className="py-24 lg:py-32 border-t border-border">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="section-label mb-4">Pricing</div>
        <h2 className="font-display text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
          Pricing for compliance files, records, and controlled certificate programs.
        </h2>
        <p className="mt-5 max-w-3xl mx-auto text-lg text-muted-foreground leading-relaxed">
          Start with an issuer workspace. Move into certificate administration only when the legal document, responsible party, evidence file, and transfer policy are ready.
        </p>
      </div>

      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        {pricingTiers.map((plan) => (
          <div key={plan.id} className="rounded-2xl border border-border bg-card p-7 flex flex-col hover:border-primary/40 transition-colors">
            <div className="mb-5">
              <h3 className="font-display text-xl font-bold text-foreground">{plan.name}</h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{plan.purpose}</p>
            </div>
            <div className="font-mono text-xl font-bold text-foreground mb-6">{plan.priceRange}</div>
            <div className="space-y-3 mb-8 flex-1">
              {plan.features.map((feature) => (
                <div key={feature} className="flex items-start gap-3 text-sm text-foreground/85">
                  <Check className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            <a href="#package-fit" className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-5 py-3 font-semibold text-foreground hover:bg-muted transition-colors">
              Check package fit <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        ))}
      </div>

      <div className="mt-8 flex items-start gap-3 rounded-xl border border-border bg-muted/40 p-4">
        <Info className="w-4 h-4 text-muted-foreground shrink-0 mt-0.5" />
        <p className="text-sm text-muted-foreground leading-relaxed">
          {pricingDisclaimer} Legal, trustee, fiduciary, tax, accounting, licensed-provider, blockchain gas, and third-party service costs are separate unless expressly included in a signed agreement.
        </p>
      </div>

      <PackageFitQuiz />
    </div>
  </section>
);

export default Pricing;
